import { ReactNode } from 'react';
import { Profile2User } from 'iconsax-react';
import InfoText from './InfoText';
import TitleText from './TitleText';

type Props = {
  title: string;
  number: string | number;
  icon?: ReactNode;
  trendNode?: ReactNode;
};

const HomeStatCard = ({ number, title, icon }: Props) => {
  return (
    <div className="flex gap-3 bg-white rounded-xl border border-gray-100 px-4 py-6 shadow-sm" data-test="home-stat-card">
      <div className="flex items-start pt-1">
        <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center" data-test="home-stat-card-icon">
          {icon || <Profile2User size={20} color="#4DA167" variant="Outline" />}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <InfoText
          text={title}
          size="sm"
          className="!font-normal leading-none text-[#777777]"
          maxLength="FULL"
        />
        <TitleText
          text={String(number)}
          size="2xl"
          className="!font-semibold font-lufga leading-[30px] text-[#090909]"
        />
      </div>
    </div>
  );
};

export default HomeStatCard;
